<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">我的消息列表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="基地名称">
          <el-input v-model="formInline.name" @blur="handleQuery" placeholder="请输入基地名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button type="primary" @click="handleAdd()">新增实训基地</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="downloadFile">下载用户导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params"     :btnTitle="btnTitle"></Importt>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="title" min-width="160" label="标题">
        </custom-table-column>
        <custom-table-column prop="content" min-width="200" label="内容">
        </custom-table-column>
        <custom-table-column label="消息类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.type=='system'" style="color:var(--blue);">系统消息</span>
          </template>
        </custom-table-column>
        <custom-table-column label="阅读状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.is_read" style="color:var(--blue);">已读</span>
            <span v-else style="color:var(--ligtGreen);">未读</span>
          </template>
        </custom-table-column>

        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleRead(scope.row)" type="text" size="small">标记已读</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="基地名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入基地名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="性质" prop="prop">
          <el-input v-model="ruleForm.prop" placeholder="请输入性质" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="院系" prop="structure_1">
          <el-input v-model="ruleForm.structure_1" placeholder="请输入院系" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="person">
          <el-input v-model="ruleForm.person" placeholder="请输入负责人" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="面积" prop="area">
          <el-input v-model="ruleForm.area" placeholder="请输入面积" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="工位数" prop="workstation">
          <el-input v-model="ruleForm.workstation" placeholder="请输入工位数" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',creatTrainBase)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateTrainBase)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>{{delText}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMessage">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog :close-on-click-modal="false"  title="组织结构" :visible.sync="organDialogVisible" width="560px">
      <div style="padding:20px;background:#fff;min-width:500px;min-height:200px;">
        <el-tree :data="treeData" node-key="id" ref="tree" :check-strictly="true" :expand-on-click-node="true" show-checkbox :default-checked-keys="checkKeys" :props="defaultProps" default-expand-all>
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindOrgan">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog> -->
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

import Vue from 'vue';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan],
  data() {
    
    return {
      classRooms: [],
      
      checkKeys: [],
      defaultProps: {
        children: 'sub',
        label: 'name',
      },
      formInline: {
        name: '',
      },
      ruleForm: {
        name: '',
        prop: '',
        structure_1: '',
        person: '',
        area: '',
        workstation: '',
      },
      treeData: '',
      rules: {
        name: [{ required: true, message: '请输入实训基地名称', trigger: 'blur' }],
        prop: [{ required: true, message: '请输入性质', trigger: 'blur' }],
        structure_1: [{ required: true, message: '请输入院系', trigger: 'blur' }],
        person: [{ required: true, message: '请输入负责人', trigger: 'blur' }],
        area: [{ required: true, message: '请输入面积', trigger: 'blur' }],
        workstation: [{ required: true, message: '请输入工位数', trigger: 'blur' }],

        // password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      organDialogVisible: false,
      type: 'add',
      tableName: '实训日志',
      uid: '',
    };
  },
  created() {},
  mounted() {
    // this.getList();
    // this.getTree();
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    formatter(row) {
      let slist = row.structureList;
      if (slist && slist.length) {
        slist = slist.map((item) => {
          return item.structure_text;
        });
      }
      return slist.join('<br/>');
      // console.log(row, column)
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },

    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    async getTree() {
      let res = await this.$api.instance.getOrgans();
      if (res.code == 0 && res.data) {
        this.treeData = res.data;
      }
    },
    handleRead(id) {
      this.confirmBox('warning', '是否将该消息标记为已读', { id }, this.read);
    },
    async read(params) {
      let res = await this.$api.update.updateRead(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '标记成功！',
        });
        // this.dialogVisible = false;
        this.getNewMessages()
        this.getList();
      }
    },
    async getNewMessages() {
      let res = await this.$api.instance.getNewMessages({ count: 9999 });
      if (res.code == 0) {
        // this.doge = res.data.length;
        this.$store.commit('setDoge', res.data.length);
      }
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMessage() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteMessage(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.getList();
      }
    },
    async creatTrainBase() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      // if (params.lesson_time) {
      //   let timee = params.lesson_time.getTime() / 1000;
      //   params.lesson_time = this.$until.getTimeStr(timee, '-');
      // }
      let res = await this.$api.creat.creatTrainBase(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateTrainBase() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      // console.log(params)
      // return
      let res = await this.$api.update.updateTrainBase(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = {
        page: this.$refs.pageChild.page,
        size: this.$refs.pageChild.size,
      };
      // if (this.formInline.name) {
      //   params.name = this.formInline.name;
      // }
      let res = await this.$api.query.getMessages(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
